import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

export interface HintsSliceInterface {
    formVisible: boolean,
    formVariant: "new" | "edit",

    editId: string,
    editTitle: string,
    editAlias: string,
    editContent: string,
    editActive: 0 | 1,
    editHintLocationsId?: number | null,
    editLocationDescription: string,

    deleteModalVisible: boolean,
    deleteId: string,
    deleteTitle: string,
}

function getInitialState(): HintsSliceInterface {
    return {
        formVisible: false,
        formVariant: "new",

        editId: "",
        editTitle: "",
        editAlias: "",
        editContent: "",
        editActive: 1,
        editHintLocationsId: undefined,
        editLocationDescription: "",

        deleteId: "",
        deleteTitle: "",
        deleteModalVisible: false,
    }
}

export const HintsSlice = createSlice({
    name: "HintsSlice",
    initialState: getInitialState(),
    reducers: {
        reset: () => {
            return getInitialState()
        },
        updateFields: (state, action: PayloadAction<Partial<HintsSliceInterface>>) => {
            Object.assign(state, action.payload)
        }
    },
});

export const {
    reset,
    updateFields
} = HintsSlice.actions;

export const HintsSelectors = {
    formVisible: (state: RootState) => state.hints.formVisible,
    formVariant: (state: RootState) => state.hints.formVariant,

    editId: (state: RootState) => state.hints.editId,
    editTitle: (state: RootState) => state.hints.editTitle,
    editAlias: (state: RootState) => state.hints.editAlias,
    editContent: (state: RootState) => state.hints.editContent,
    editActive: (state: RootState) => state.hints.editActive,
    editHintLocationsId: (state: RootState) => state.hints.editHintLocationsId,
    editLocationDescription: (state: RootState) => state.hints.editLocationDescription,

    deleteModalVisible: (state: RootState) => state.hints.deleteModalVisible,
    deleteId: (state: RootState) => state.hints.deleteId,
    deleteTitle: (state: RootState) => state.hints.deleteTitle,
}

export const HintsReducer = HintsSlice.reducer;
